import { Button, Flex, Progress } from "antd";
import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import styles from "./AccountSetup.module.css";
import logo from "../../../assets/images/logo.png";
import {
  InputField,
  PhoneInput,
  SubmitButton,
  TextComponent,
} from "../../../components";
import { LuEye, LuEyeOff } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import documentbox from "../../../assets/images/browse-documents.png";
import { FileUploader } from "react-drag-drop-files";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import Dragger from "antd/es/upload/Dragger";
import { InboxOutlined } from "@ant-design/icons";
import { message, Upload } from "antd";
import { HiMenuAlt2 } from "react-icons/hi";
import { showAlert } from "../../../Store/Actions/GeneralActions";
import { AuthMiddleware } from "../../../Store/Middlewares/AuthMiddleware";
import uploadImg from "../../../assets/images/uploadImg.jpg";

const fileTypes = ["JPG", "PDF", "GIF"];
const AccountSetup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [address, setAddress] = useState("");
  // const [dealerId, setDealerId] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [percent, setPercent] = useState(1);
  const [identificationNo, setIdentificationNo] = useState("");
  const [licenseNo, setLicenseNo] = useState("");
  const [file, setFile] = useState(null);
  const { width } = useWindowDimensions();
  const [companyLogo, setCompanyLogo] = useState();
  const [businessYears, setBusinessYears] = useState("");
  const [serviceDesc, setServiceDesc] = useState("");

  const hiddenFileInput = useRef();
  const handleClick = () => {
    hiddenFileInput.current.click();
  };

  const { Dragger } = Upload;

  const handleFileHandler = () => {
    hiddenFileInput.current.click();
  };

  const onSubmitForm = () => {
    if (percent == 1 && (!name || !email || !contactNo || !address)) {
      dispatch(
        showAlert({
          message: "All fields are required",
          type: "error",
          status: 400,
        }),
      );
    } else if (percent == 2 && (!file || !identificationNo || !licenseNo)) {
      dispatch(
        showAlert({
          message: "All fields are required",
          type: "error",
          status: 400,
        }),
      );
    } else if (
      percent == 3 &&
      (!companyLogo || !businessYears || !serviceDesc)
    ) {
      dispatch(
        showAlert({
          message: "All fields are required",
          type: "error",
          status: 400,
        }),
      );
    } else {
      let userData = {
        business_name: name,
        business_email: email,
        business_contact_no: contactNo,
        business_address: address,
        // dealer_id: dealerId,
        tax_identification: file,
        tax_identification_no: identificationNo,
        // tax_identification_no: identificationNo,
        business_license_no: licenseNo,
        logo: companyLogo,
        years_in_business: businessYears,
        description: serviceDesc,
        step: percent,
      };
      dispatch(AuthMiddleware.accountSetup(userData)).then(() => {
        setPercent(percent + 1);
        percent == 3 && navigate("/verificationProcess");
      });
    }
  };

  return (
    <div className={styles.mainCont}>
      <div className={styles.leftCont}>
        <img src={logo} className={styles.logoImg} />
      </div>
      <div className={styles.rightCont}>
        <div className={styles.subRightCont}>
          <div className={styles.textDiv}>
            <div className={styles.welcomeDiv}>
              <TextComponent
                className={styles.welcomeHeading}
                text={"Welcome!"}
              />
              <Flex gap={10} vertical style={{ marginLeft: "10px" }}>
                <Progress
                  showInfo={false}
                  trailColor={"var(--light-blue)"}
                  strokeLinecap={"round"}
                  strokeColor={"var(--secondary-color)"}
                  percent={percent == 1 ? 33 : percent == 2 ? 66 : 100}
                  steps={3}
                  size={{ width: width < 500 ? 50 : 100, height: 8 }}
                  className={styles.progressBar}
                  //   style={{width: "100px", height: "6px", borderRadius: "10px"}}
                />
              </Flex>
            </div>
            <TextComponent
              className={styles.welcomeText}
              text={"Enter your business details"}
            />
          </div>
          {percent == 1 ? (
            <div className={styles.inputDiv}>
              <InputField
                label={"Business Name"}
                placeholder={"Write here"}
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <InputField
                label={"Business Email"}
                placeholder={"Write here"}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {/* <InputField
                label={"Primary Contact Number"}
                placeholder={"Write here"}
                value={contactNo}
                onChange={(e) => setContactNo(e.target.value)}
              /> */}
              <PhoneInput
                label={"Primary Contact Number"}
                placeholder={"Write here"}
                className={styles.input}
                value={contactNo}
                onChange={setContactNo}
              />
              <InputField
                label={"Business Address"}
                placeholder={"Write here"}
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
              {/* <InputField
                label={"Dealer Id"}
                placeholder={"Write here"}
                value={dealerId}
                onChange={(e) => setDealerId(e.target.value)}
              /> */}
            </div>
          ) : percent == 2 ? (
            <div className={styles.inputDiv}>
              <Dragger
                style={{
                  backgroundColor: "transparent",
                }}
                accept=".txt, .csv, .pdf"
                showUploadList={true}
                // onDownload={}
                maxCount={1}
                beforeUpload={(file) => {
                  const reader = new FileReader();

                  reader.onload = (e) => {
                    setFile(file);
                  };
                  reader.readAsText(file);

                  // Prevent upload
                  return false;
                }}
              >
                <div className={styles.subDragger}>
                  <div className={styles.hamburgIcon}>
                    <HiMenuAlt2 />
                  </div>
                  <TextComponent
                    text={"Drag & Drop File"}
                    style={{ fontSize: "var(--dashboard_tabs-font-size)" }}
                  />
                  <TextComponent
                    text={"Or"}
                    style={{ fontSize: "var(--dashboard_tabs-font-size)" }}
                  />
                  <TextComponent text={"Browse"} className={styles.browseBtn} />
                </div>
              </Dragger>

              {/* <img
                src={documentbox}
                style={{ cursor: "pointer" }}
                onClick={handleClick}
              />
              <input
                type="file"
                accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, application/pdf"
                onChange={(e) => setFile(e.target.files[0])}
                ref={hiddenFileInput}
                style={{ display: "none" }}
              /> */}
              <TextComponent
                text={" business license and tax ID certificate"}
                className={styles.documentText}
              />
              <InputField
                className={styles.input}
                label={"Tax Identification Number"}
                placeholder={"Write here"}
                value={identificationNo}
                onChange={(e) => setIdentificationNo(e.target.value)}
                maxLength={15}
              />
              <InputField
                className={styles.input}
                label={"Business License Number"}
                placeholder={"Write here"}
                value={licenseNo}
                onChange={(e) => setLicenseNo(e.target.value)}
                maxLength={25}
              />
              {/* <FileUploader handleChange={(file)=>setFile(file)} name="file" types={fileTypes} /> */}
            </div>
          ) : (
            <>
              <div className={styles.uploadLogoDiv}>
                <img
                  onClick={handleFileHandler}
                  src={
                    companyLogo ? URL.createObjectURL(companyLogo) : uploadImg
                  }
                  className={styles.uploadLogo}
                />
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setCompanyLogo(e.target.files[0])}
                  ref={hiddenFileInput}
                  style={{ display: "none" }}
                />
              </div>
              <InputField
                placeholder={"Write here"}
                label={"Years in business"}
                type={"number"}
                value={businessYears}
                onChange={(e) => setBusinessYears(e.target.value)}
              />
              <InputField
                placeholder={"Write here"}
                label={"Description of services"}
                //   type={"number"}
                value={serviceDesc}
                onChange={(e) => setServiceDesc(e.target.value)}
              />
            </>
          )}
          <div className={styles.btn}>
            {/* {percent == 50 ? (
            ) : (
              <SubmitButton
                title={"Next"}
                onClick={() => navigate("/businessProfileSetup")}
              />
            )} */}
            <SubmitButton onClick={onSubmitForm} title={"Next"} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSetup;
